import { Document, Font } from "@react-pdf/renderer";
import { Order } from "models/Order";
import { MediaEntity } from "models/MediaEntity";
import AvenirNext from "assets/fonts/AvenirNextFont.ttf";
import AvenirNextBold from "assets/fonts/AvenirNextLTPro-Bold.ttf";
import FrontPage from "./pages/FrontPage";
import OrderPage from "./pages/OrderPage";
import ChecklistPage from "./pages/ChecklistPage";
import InspectionsPage from "./pages/InspectionsPage";
import LocalizationProvider from "./localization/LocalizationContext";
import { Language } from "./localization/types";

Font.register({
  family: "Avenir Next",
  fonts: [
    { src: AvenirNext, fontStyle: "normal", fontWeight: "normal" },
    { src: AvenirNextBold, fontStyle: "normal", fontWeight: 700 },
  ],
});

// Don't hyphenate any words in the PDF
Font.registerHyphenationCallback((word) => [word]);

// Create Document Component
const PdfDocument = (order: Order, images: MediaEntity[], language: Language) => {
  return (
    <Document>
      <LocalizationProvider language={language}>
        <FrontPage />

        <OrderPage order={order} />

        {order.customerApprovals.length > 1 && (
          <InspectionsPage inspections={order.customerApprovals} />
        )}

        {order.checklists
          .filter((checklist) => !checklist.excludedFromReport)
          .map((checklist) => (
            <ChecklistPage
              key={checklist.id}
              checklist={checklist}
              images={images.filter((image) => image.checklist === checklist.id)}
            />
          ))}
      </LocalizationProvider>
    </Document>
  );
};

export default PdfDocument;
